import { LanguageProvider } from "@/i18n";
import { ThemeProvider } from "@/theme";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import SeasonBanner from "@/components/SeasonBanner";
import Marquee from "@/components/Marquee";
import Villa from "@/components/Villa";
import Lodging from "@/components/Lodging";
import Piscine from "@/components/Piscine";
import Jacuzzi from "@/components/Jacuzzi";
import Situation from "@/components/Situation";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import BackToTop from "@/components/BackToTop";

function Page() {
  useLenis();
  return (
    <div className="bg-night text-bone min-h-screen" data-testid="villa-mana-page">
      <Nav />
      <main>
        <Hero />
        <SeasonBanner />
        <Marquee />
        <Villa />
        <Lodging />
        <div id="bassins">
          <Piscine />
          <Jacuzzi />
        </div>
        <Situation />
        <Gallery />
        <Reviews />
        <Booking />
      </main>
      <Contact />
      <WhatsAppFloat />
      <BackToTop />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Page />
      </LanguageProvider>
    </ThemeProvider>
  );
}
